import React from 'react';
import { X } from 'lucide-react';
import dayjs from 'dayjs';
import { Card, CardContent } from './ui/card';
import { Select } from './ui/select';
import { Input } from './ui/input';
import { Button } from './ui/button';

function DateRangeFilter({ onFilterChange, defaultHours = null }) {
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [quickFilter, setQuickFilter] = React.useState(
    defaultHours ? `${defaultHours}h` : 'all'
  );

  const handleQuickFilter = (value) => {
    setQuickFilter(value);
    setStartDate(null);
    setEndDate(null);

    if (value === 'all') {
      onFilterChange({ startDate: null, endDate: null, hours: null });
    } else if (value.endsWith('h')) {
      const hours = parseInt(value);
      const end = dayjs();
      const start = end.subtract(hours, 'hour');
      onFilterChange({
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        hours: null,
      });
    }
  };

  const handleCustomDateApply = () => {
    if (startDate && endDate) {
      onFilterChange({
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        hours: null,
      });
    }
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    setQuickFilter('all');
    onFilterChange({ startDate: null, endDate: null, hours: null });
  };

  return (
    <Card className="mb-4">
      <CardContent className="flex flex-wrap items-center gap-3 p-4">
        <span className="text-sm font-medium text-muted-foreground">Filter by:</span>

        <div className="w-44">
          <Select
            value={quickFilter}
            onChange={(e) => handleQuickFilter(e.target.value)}
          >
            <option value="all">All Time</option>
            <option value="24h">Last 24 Hours</option>
            <option value="48h">Last 48 Hours</option>
            <option value="168h">Last 7 Days</option>
            <option value="720h">Last 30 Days</option>
            <option value="custom">Custom Range</option>
          </Select>
        </div>

        {quickFilter === 'custom' && (
          <>
            <Input
              type="datetime-local"
              value={startDate ? dayjs(startDate).format('YYYY-MM-DDTHH:mm') : ''}
              onChange={(e) =>
                setStartDate(e.target.value ? dayjs(e.target.value) : null)
              }
              className="w-52"
            />
            <Input
              type="datetime-local"
              value={endDate ? dayjs(endDate).format('YYYY-MM-DDTHH:mm') : ''}
              onChange={(e) =>
                setEndDate(e.target.value ? dayjs(e.target.value) : null)
              }
              className="w-52"
            />
            <Button
              size="sm"
              onClick={handleCustomDateApply}
              disabled={!startDate || !endDate}
            >
              Apply
            </Button>
          </>
        )}

        {(startDate || endDate || quickFilter !== 'all') && (
          <Button variant="outline" size="sm" onClick={handleClear}>
            <X />
            Clear
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

export default DateRangeFilter;
